import type { ButtonHTMLAttributes, ReactNode } from "react";
import { injectCss } from "./injectCss";

const CSS = `
.js-iconbtn{
  --_bg:transparent;--_fg:var(--text-muted);
  display:inline-flex;align-items:center;justify-content:center;
  border:none;border-radius:var(--radius-md);background:var(--_bg);color:var(--_fg);
  cursor:pointer;transition:background var(--dur-fast) var(--ease-out),color var(--dur-fast) var(--ease-out),transform var(--dur-fast) var(--ease-out);
}
.js-iconbtn:hover:not([disabled]){--_bg:var(--neutral-100);--_fg:var(--text-strong)}
.js-iconbtn:active:not([disabled]){transform:scale(.92)}
.js-iconbtn:focus-visible{outline:none;box-shadow:var(--ring-brand)}
.js-iconbtn[disabled]{opacity:.45;cursor:not-allowed}
.js-iconbtn--sm{width:32px;height:32px}
.js-iconbtn--md{width:40px;height:40px}
.js-iconbtn--lg{width:48px;height:48px}
.js-iconbtn--brand:hover:not([disabled]){--_bg:var(--brand-subtle);--_fg:var(--brand)}
.js-iconbtn--solid{--_bg:var(--brand);--_fg:#fff}
.js-iconbtn--solid:hover:not([disabled]){--_bg:var(--brand-hover);--_fg:#fff}
`;

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  size?: "sm" | "md" | "lg";
  tone?: "default" | "brand" | "solid";
  label: string;
  children?: ReactNode;
}

export function IconButton({
  size = "md",
  tone = "default",
  className = "",
  label,
  children,
  ...rest
}: IconButtonProps) {
  injectCss("js-iconbtn-css", CSS);
  const cls = [
    "js-iconbtn",
    `js-iconbtn--${size}`,
    tone !== "default" ? `js-iconbtn--${tone}` : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <button type="button" className={cls} aria-label={label} title={label} {...rest}>
      {children}
    </button>
  );
}
